module.exports = __webpack_public_path__ + "img/ipc_intro2.fe35cd4a.png";